import { useEffect } from "react";
import useInterfaceConfig from "@hooks/useInterfaceConfig";

const DynamicMetadata = () => {
  const interfaceConfig = useInterfaceConfig();

  useEffect(() => {
    const { title, favicon } = interfaceConfig.metadata;

    const favicon_url = `${import.meta.env.VITE_URL_STATIC_RESOURCES}/${favicon}`;
    document.title = title;

    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon_url);
    } else {
      const link = document.createElement("link");
      link.rel = "icon";
      link.type = "image/svg+xml";
      link.href = favicon_url;
      document.head.appendChild(link);
    }
  }, [interfaceConfig]);

  return null;
};

export default DynamicMetadata;
